// Used in Update App

import React from "react";
import { Main, Body, Box, TextBox } from './commonStyles';


export default function Blank({content, smallWindow}) {
    return (
        <Main content={content.styles}>
            <h2>&nbsp;Colour of Page Titles (Main text)</h2>
            <Body content={{smallWindow: smallWindow}}>
                <Box content={{...content.styles, 'maxBoxWidth': 'Max'}}>
                <TextBox>
                    <h3>This is a text box and the colour of Highlights and Section titles</h3>
                    <h4>Colour of sub-headings</h4>
                    Colour of normal text
                </TextBox>
                </Box>
            </Body>
        </Main>
    )
}